<button class="btn btn-add btn-block" type="button" :style="{'width': width}">{{ label }}</button>
